import { createBusinessLogger } from '@/utils/logger/businessLogger';

// 营销榜单名称常量
export const BESTSELLERS_EVENT_NAMES = {
  INIT_CATEGORY_SIDE_FAIL: 'init_category_side_fail', // 初始化榜单数据失败
  SIDEBAR_LOAD_FAIL: 'sidebar_load_fail', // 榜单分类获取失败
  BANNER_IMG_FETCH_FAIL: 'banner_img_fetch_fail', // banner图下发失败
} as const;

// 导出类型定义，既可以当常量用也可以当类型用
export type BestSellersEventNames = typeof BESTSELLERS_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = [];

// Business Logger 实例 - 邀请有礼
export const bestSellersBusinessLogger = createBusinessLogger<BestSellersEventNames>(
  'best_sellers',
  categoryNames,
);
